import script from "./loginPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./loginPage.vue?vue&type=script&setup=true&lang=ts"

import "./loginPage.vue?vue&type=style&index=0&id=2904bb5c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2904bb5c"]])

export default __exports__